<template>
  <div class="tw:relative" :title="$t('brand.switcher.hint')">
    <span
      class="tw:absolute tw:-top-2.5 tw:left-2 tw:z-10 tw:rounded-sm tw:bg-orange-600 tw:px-1.5 tw:text-10 tw:leading-4 tw:font-semibold tw:tracking-caps tw:text-white tw:uppercase">
      {{ $t('brand.switcher.badge') }}
    </span>
    <LeadSelect
      :model-value="brand.key"
      :options="options"
      :aria-label="$t('brand.switcher')"
      @update:model-value="onSelect" />
  </div>
</template>

<script setup lang="ts">
import LeadSelect, { type LeadSelectOption } from '@/components/lead-design/LeadSelect.vue';
import { brand, brandList, setBrandOverride } from '@/config/brands';
import type { Brand, BrandKey } from '@/config/brands/types';

/* ---------------------------------- STATE ----------------------------------- */
const options: LeadSelectOption[] = brandList.map((item) => ({ value: item.key, label: brandLabel(item) }));

/* ---------------------------------- METHODS --------------------------------- */
/** switching reloads the page so every module picks up the new brand */
function onSelect(value: string | string[] | null) {
  setBrandOverride(String(value) as BrandKey);
}

/** brands can share a name (the LEAD builds), so the key disambiguates */
function brandLabel(item: Brand): string {
  const shared = brandList.some((other) => other !== item && other.name === item.name);
  return shared ? `${item.name} (${item.key})` : item.name;
}
</script>
